import React from 'react';
import '../CSS/userpanel.css';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../reducers/loginReducers';
import { NavLink, useNavigate } from 'react-router-dom';
const UserPanel = () => {
    const loginInfo = useSelector((state) => state.login);
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const userEmail = loginInfo ? loginInfo.email : '';
    const userProfilePic = loginInfo ? loginInfo.MyProfile : '';

    const handleLogout = () => {
        dispatch(logout());
        localStorage.removeItem('infinity_user');
        if(window.location.toString().includes("/my") || window.location.toString().includes("/user") || window.location.toString().includes("/course")){
            navigate("/")
        }
    };

    return (
        <div style={{ width: 'fit-content', height: 'fit-content', backgroundColor: 'rgb(243, 242, 242)' }}>
            <div className="user-panel-margin">
                <img className="float-left rounded-circle" src={loginInfo.profile_pic || "/webdp.gif"} alt="Profile" />
                <div>{userEmail}</div>
                <div>
                    <ul className="navigation">
                        <li><NavLink to="/my">Dashboard</NavLink></li>
                        <li><NavLink to="/user/profile">Profile</NavLink></li>
                        <li><NavLink to="/user/courses">My Courses</NavLink></li>
                        <li><NavLink to="/user/downloads">Downloads</NavLink></li>
                    </ul>
                    <button className='navigation-button' onClick={handleLogout}>Log Out</button>
                </div>
            </div>
        </div>
    );
};

export default UserPanel;
